var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeModel)?_c('div',{staticClass:"product-details-note"},[_c('h4',{staticClass:"product-details-note-heading"},[_vm._v(_vm._s(_vm.$t("Comment")))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.activeModel.notes))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }